
import lineChart from './line-chart.js';

// ! rename the function to align with the widget name
export const sonataLineChart = async () => {
    const el = document.querySelector('.curious-sonata-line-chart');
    if (!el) return;

    // ------------------------------------------------------------

    const endpoint = el.getAttribute('data-endpoint');
        if (!endpoint) {
            console.error('No endpoint specified for the sonata-topline-meta widget');
            return;
        }
        const url = `${window.apiUri}${endpoint}/meta`
        try {
            const response = await fetch(url)
            if (!response.ok) {
                throw new Error(`Response status: ${response.status}`)
            }
            const data = await response.json();
       
            let parsedData = []
            
            for (let [collection, meta] of Object.entries(data)) {
                let count = 0
                for(let [metaKey, metaValue] of Object.entries(meta.meta)) {
                    count += parseInt(metaValue)
                }
                parsedData.push({
                    label: collection,
                    value: count
                })
            }

            if(parsedData.length === 0) {
                el.classList.add('hidden')
                console.warn('No data available for the sonata-line-chart widget');
                return;
            }

            lineChart(el, parsedData);

            el.classList.remove('loading');
            
        } catch(error) {
            console.error(error.message)
        }

    // ------------------------------------------------------------
    // ! Remember to call this function in the main script file: /site/src/js/site.js

}

